export const imageBreakpoints: Record<number, number | number[]> = {
	1920: 600,
	1680: 600,
	1600: 600,
	1536: 500,
	1440: 500,
	1366: 400,
	1280: 400,
	428: [400, 500, 600],
	414: [400, 500, 600],
	412: [400, 500, 600],
	393: [400, 500, 600],
	390: [350, 400, 500],
	385: [350, 400, 500],
	384: [350, 400, 500],
	375: [350, 400, 500],
	360: [350, 400, 500],
	320: [300, 400, 500],
};
